import React from "react";

import {borderColour} from "../../../../style/styleConsts";
import {hasNoVolume} from "../volumeCalculator";

export const VolumeChart = (props) => (
    hasNoVolume(props) ? null
        : <div className="t-volume" style={{
            transition:      "width 0.3s",
            width:           props.percentageOfOpenIdeas / props.maxVolume * 100,
            height:          10,
            backgroundColor: borderColour
            }}/>
);